import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { deltamathAPI } from "../../manager/utils";
import { CheckoutStatus } from "../types";

interface TeacherAccountInfoResponse {
  teacher: {
    has_integral: boolean;
  };
  license: {
    expires: number;
    has_longest_license: boolean;
    integral_active: boolean;
    licenseType: string;
    non_renewal_confirmed: boolean;
    operative_subscription_type: "none" | "school" | "individual" | undefined;
    plus_active: boolean;
  };
}

interface TeacherPricesResponse {
  productPrefix: string;
  priceData: Record<string, number>;
  discountDate: string;
  proratedDiscount: number;
}

export const teacherApi = createApi({
  reducerPath: "teacherApi",
  baseQuery: fetchBaseQuery({ baseUrl: deltamathAPI() }),
  endpoints: (builder) => ({
    teacherAccountInfo: builder.query<TeacherAccountInfoResponse, void>({
      query: () => "/teacher/account/info",
    }),
    teacherPrices: builder.query<TeacherPricesResponse, void>({
      query: () => "/payments/checkout/prices",
    }),
    updateTeacherData: builder.mutation<CheckoutStatus, void>({
      query: () => ({
        url: "/payments/checkout/status",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useTeacherAccountInfoQuery,
  useTeacherPricesQuery,
  useUpdateTeacherDataMutation,
} = teacherApi;
export default teacherApi.reducer;
